export default [
  {
    path: '/activity-20251111-main',
    component: () => import('./Page.vue'),
    meta: { expire: '2025-11-20T23:59:59.000+08:00', title: '全城告白(双十一)', id: 5 },
  },
  {
    path: '/activity-20251111-rule',
    component: () => import('./Rule.vue'),
    meta: { expire: '2025-11-20T23:59:59.000+08:00', title: '全城告白(双十一)规则说明', id: 5 },
  },
]
